import { useState, useEffect } from "react";
import { Mail, Loader2, Send, CheckCircle2, XCircle, RefreshCw } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { formatDateTimeIT } from "@/utils/datetime";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmailDiagnosticsSection() {
  const [log, setLog] = useState([]);
  const [to, setTo] = useState("info@mvtrasporti.com");
  const [sending, setSending] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("mv_admin_token");
  const h = { headers: { Authorization: `Bearer ${token}` } };

  const load = () => {
    setLoading(true);
    axios.get(`${API}/admin/settings/email-log?limit=30`, h).then((r) => setLog(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);

  const sendTest = async () => {
    setSending(true);
    try {
      const r = await axios.post(`${API}/admin/settings/email-test`, { to }, h);
      toast.success(`Email di test inviata a ${r.data.to} (id Resend: ${r.data.resend_id || "n/d"})`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invio fallito");
    } finally {
      setSending(false);
      load();
    }
  };

  return (
    <section className="bg-white border border-zinc-200 rounded-sm p-6" data-testid="section-email-diagnostics">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 rounded-sm bg-sky-100 flex items-center justify-center flex-shrink-0"><Mail size={18} className="text-sky-700" /></div>
        <div className="flex-1">
          <h3 className="font-heading text-sm font-bold uppercase tracking-widest text-zinc-800">Diagnostica Email</h3>
          <p className="text-sm text-zinc-500 mt-1">Invia un'email di prova e controlla l'esito reale di ogni invio (accettato da Resend o errore). Se risulta inviata ma non la trovi, controlla la cartella spam/indesiderata.</p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <input type="email" value={to} onChange={(e) => setTo(e.target.value)} className="h-10 w-72 px-3 border border-zinc-300 rounded-sm text-sm focus:border-[#FF5200] outline-none" data-testid="email-test-to" />
        <button onClick={sendTest} disabled={sending || !to.includes("@")} className="inline-flex items-center gap-2 h-10 px-4 bg-[#FF5200] text-white text-xs font-bold uppercase tracking-widest rounded-sm hover:bg-[#e04800] disabled:opacity-50" data-testid="email-test-send">
          {sending ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />} Invia email di test
        </button>
        <button onClick={load} className="inline-flex items-center gap-1 h-10 px-3 border border-zinc-300 text-xs font-bold uppercase tracking-widest rounded-sm hover:border-[#FF5200]" data-testid="email-log-refresh">
          <RefreshCw size={12} className={loading ? "animate-spin" : ""} /> Aggiorna
        </button>
      </div>
      <div className="border border-zinc-200 rounded-sm overflow-x-auto" data-testid="email-log-table">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-zinc-50 text-[10px] uppercase tracking-widest text-zinc-500">
            <tr><th className="text-left px-3 py-2">Quando</th><th className="text-left px-3 py-2">Destinatario</th><th className="text-left px-3 py-2">Oggetto</th><th className="text-left px-3 py-2">Esito</th></tr>
          </thead>
          <tbody>
            {log.length === 0 && <tr><td colSpan={4} className="px-3 py-4 text-center text-zinc-400 text-xs">Nessun invio registrato (il registro parte da oggi).</td></tr>}
            {log.map((e, i) => (
              <tr key={i} className="border-t border-zinc-100 align-top" data-testid={`email-log-row-${i}`}>
                <td className="px-3 py-2 text-xs text-zinc-500 whitespace-nowrap">{formatDateTimeIT(e.sent_at)}</td>
                <td className="px-3 py-2 text-xs font-mono">{(e.to || []).join(", ")}</td>
                <td className="px-3 py-2 text-xs text-zinc-700">{e.subject}</td>
                <td className="px-3 py-2 text-xs">
                  {e.ok
                    ? <span className="inline-flex items-center gap-1 text-emerald-700"><CheckCircle2 size={12} /> accettata{e.resend_id ? <span className="text-zinc-400 font-mono"> · {String(e.resend_id).slice(0, 8)}</span> : null}</span>
                    : <span className="inline-flex items-center gap-1 text-red-600" title={e.error || ""}><XCircle size={12} /> {e.error ? String(e.error).slice(0, 90) : "errore"}</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
